module.exports = __webpack_public_path__ + "img/sDrgBlitz_193x205.f041267d.png";